import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "../../TippyV2";
import { useBuilderStore } from "../Hooks/useBuilderStore";

export const ToggleCollapseButton = () => {
  const { toggleRightSidebar, isRightSidebarOpen } = useBuilderStore(state => ({
    toggleRightSidebar: state.toggleRightSidebar,
    isRightSidebarOpen: state.isRightSidebarOpen,
  }));

  const chevronType = isRightSidebarOpen
    ? "20-chevron-right"
    : "20-chevron-left";

  const labelOpen = t("builder_ui.collapsible_sidebar.open_properties");
  const labelClose = t("builder_ui.collapsible_sidebar.close_properties");
  const label = isRightSidebarOpen ? labelClose : labelOpen;

  return (
    <TippyV2 content={label} placement="left" arrow={false}>
      <button
        type="button"
        aria-label={label}
        onClick={toggleRightSidebar}
        className={classNames(
          "border-primary hover:bg-tertiary bg-primary flex size-10 rounded-l-lg rounded-r-none border border-r-0 px-1 py-2 shadow-md transition-colors",
          "focus:ring-transparent focus-visible:!outline focus-visible:!outline-2 focus-visible:!outline-offset-2",
        )}
        aria-expanded={isRightSidebarOpen}
      >
        <Icon type={chevronType} size={20} />
      </button>
    </TippyV2>
  );
};
